var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "split-screen-container" }, [
    _c("div", { staticClass: "visual-section" }, [
      _c("div", { staticClass: "image-wrapper" }, [
        _c(
          "div",
          { staticClass: "visual-slider" },
          [
            _c(
              "transition",
              { attrs: { name: _vm.transitionName, mode: "out-in" } },
              [
                _c(
                  "div",
                  {
                    key: _vm.currentVisualMediaKey,
                    staticClass: "media-frame",
                  },
                  [
                    _vm.currentVisualMediaType === "image"
                      ? _c("img", {
                          staticClass: "main-image",
                          attrs: {
                            src: _vm.currentVisualMediaUrl,
                            alt: "Onekids",
                          },
                          on: { error: _vm.handleVisualMediaError },
                        })
                      : _vm.currentVisualMediaType === "youtube"
                      ? _c("iframe", {
                          ref: "youtubeIframe",
                          staticClass: "main-video",
                          attrs: {
                            src: _vm.currentVisualMediaUrl,
                            title: "OneKids visual video",
                            allow:
                              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                            allowfullscreen: "",
                          },
                        })
                      : _c("video", {
                          ref: "nativeVideo",
                          staticClass: "main-video",
                          attrs: {
                            src: _vm.currentVisualMediaUrl,
                            controls: "",
                            preload: "metadata",
                            playsinline: "",
                          },
                          on: {
                            play: _vm.handleNativeVideoPlay,
                            pause: _vm.handleNativeVideoPause,
                            ended: _vm.handleVisualVideoEnded,
                            error: _vm.handleVisualMediaError,
                          },
                        }),
                  ]
                ),
              ]
            ),
            _vm.visualMediaItems.length > 1 &&
            _vm.currentVisualMediaType !== "image"
              ? _c(
                  "button",
                  {
                    staticClass: "skip-video-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.skipCurrentVideo },
                  },
                  [_vm._v("\n            Bỏ qua video\n          ")]
                )
              : _vm._e(),
            _vm.visualMediaItems.length > 1
              ? _c(
                  "div",
                  {
                    staticClass: "visual-indicators",
                    attrs: { "aria-label": "Trạng thái media minh họa" },
                  },
                  _vm._l(_vm.visualMediaItems, function (mediaItem, index) {
                    return _c("button", {
                      key: `${mediaItem.url}-${mediaItem.type}-${index}`,
                      staticClass: "indicator-dot",
                      class: { active: index === _vm.currentVisualImageIndex },
                      attrs: {
                        type: "button",
                        "aria-label": `Chuyển tới media ${index + 1}`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goToImage(index)
                        },
                      },
                    })
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "form-section" }, [
      _c(
        "div",
        { staticClass: "form-container" },
        [
          _c(
            "el-form",
            {
              ref: "credentials",
              staticClass: "login-standard-form",
              attrs: {
                "label-position": _vm.labelPosition,
                rules: _vm.rules,
                "label-width": "100px",
                model: _vm.credentials,
              },
            },
            [
              _c("div", { staticClass: "brand-header" }, [
                _c("img", {
                  staticClass: "login-logo",
                  attrs: {
                    src: require("@/assets/images/onekids-logo.png"),
                    alt: "Logo Onekids",
                  },
                }),
                _c("div", { staticClass: "title-login" }, [
                  _vm._v("ĐĂNG NHẬP"),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "Tên khoản", prop: "username" } },
                [
                  _c("el-input", {
                    attrs: {
                      "prefix-icon": "el-icon-phone-outline",
                      autocomplete: "username",
                      placeholder: "Nhập số điện thoại",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submitForm("credentials")
                      },
                    },
                    model: {
                      value: _vm.credentials.username,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.credentials,
                          "username",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "credentials.username",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Mật khẩu", prop: "password" } },
                [
                  _c("el-input", {
                    attrs: {
                      "prefix-icon": "el-icon-lock",
                      placeholder: "Nhập mật khẩu",
                      "show-password": "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submitForm("credentials")
                      },
                    },
                    model: {
                      value: _vm.credentials.password,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.credentials,
                          "password",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "credentials.password",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "app-type-selector",
                  attrs: { prop: "appType" },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.credentials.appType,
                        callback: function ($$v) {
                          _vm.$set(_vm.credentials, "appType", $$v)
                        },
                        expression: "credentials.appType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "plus" } }, [
                        _vm._v("Nhà trường"),
                      ]),
                      _c("el-radio", { attrs: { label: "teacher" } }, [
                        _vm._v("Giáo viên"),
                      ]),
                      _c("el-radio", { attrs: { label: "parent" } }, [
                        _vm._v("Phụ huynh"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "error",
                  style: {
                    visibility: _vm.showBadCredential ? "visible" : "hidden",
                  },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.loginError) + "\n          "
                  ),
                ]
              ),
              _c(
                "el-button",
                {
                  staticClass: "submit-btn",
                  attrs: {
                    type: "primary",
                    loading: _vm.loadingButton,
                    round: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("credentials")
                    },
                  },
                },
                [_vm._v("Đăng nhập")]
              ),
              _c("div", { staticClass: "note" }, [
                _c("span", { staticClass: "forgot-link" }, [
                  _vm._v("Liên hệ với nhà trường khi quên mật khẩu"),
                ]),
                _c("hr", { staticClass: "form-hr" }),
                _c("span", { staticClass: "slogan-text" }, [
                  _vm._v("Trẻ em hôm nay, thế giới ngày mai!"),
                ]),
              ]),
              _c("div", { staticClass: "social-links-wrapper" }, [
                _c("span", { staticClass: "social-links-title" }, [
                  _vm._v("Kết nối với OneKids"),
                ]),
                _c("div", { staticClass: "social-links" }, [
                  _c(
                    "button",
                    {
                      staticClass: "social-link social-link--onekids",
                      attrs: {
                        type: "button",
                        "aria-label": "Mở website OneKids",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openExternalLink(_vm.socialLinks.onekids)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "social-link-logo",
                        attrs: {
                          src: require("@/assets/images/onekids-logo.png"),
                          alt: "OneKids",
                        },
                      }),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "social-link social-link--facebook",
                      attrs: {
                        type: "button",
                        "aria-label": "Mở Facebook OneKids",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openExternalLink(_vm.socialLinks.facebook)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "social-icon-svg",
                          attrs: {
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M13.5 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.6 1.6-1.6H17V3.8c-.3 0-1.2-.1-2.3-.1-2.3 0-3.9 1.4-3.9 4V10H8v3h2.8v8h2.7Z",
                              fill: "currentColor",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "social-link social-link--zalo",
                      attrs: {
                        type: "button",
                        "aria-label": "Chat ngay với OneKids trên Zalo",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openZaloContact(_vm.primaryZaloPhone)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "social-icon-svg social-icon-svg--zalo",
                          attrs: {
                            viewBox: "0 0 64 64",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("rect", {
                            attrs: {
                              x: "8",
                              y: "10",
                              width: "48",
                              height: "44",
                              rx: "14",
                              fill: "currentColor",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M22 24h20v4L28.5 40H42v4H22v-4L35.5 28H22v-4Zm8 26 2.8-4h6.7L32 54l-2-4Z",
                              fill: "#ffffff",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "social-link social-link--youtube",
                      attrs: {
                        type: "button",
                        "aria-label": "Xem kênh YouTube OneKids",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openExternalLink(_vm.socialLinks.youtube)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "social-icon-svg",
                          attrs: {
                            viewBox: "0 0 24 24",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
                              fill: "currentColor",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
              _c("div", { staticClass: "app-download-wrapper" }, [
                _c("div", { staticClass: "app-download-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "app-download-link app-download-link--play",
                      attrs: {
                        type: "button",
                        "aria-label": "Tải ứng dụng OneKids trên Google Play",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openExternalLink(
                            _vm.socialLinks.googlePlay
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "app-download-icon" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "store-icon-svg",
                            attrs: {
                              viewBox: "0 0 24 24",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M4.7 3.6a1 1 0 0 0-.5.9v15a1 1 0 0 0 .5.9l8.7-8.4-8.7-8.4Zm10 9.6 2.7-2.6L7.2 4.7l7.5 8.5Zm3.5-3.4 2.6-1.5c1-.6 1-1.9 0-2.5l-2.9-1.7-2.8 2.7 3.1 3Zm-2.9 4.4 2.8 2.7 2.9-1.7c1-.6 1-1.9 0-2.5l-2.6-1.5-3.1 3Zm-8.1 5.1 10.2-5.9-2.7-2.6-7.5 8.5Z",
                                fill: "currentColor",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c("span", { staticClass: "app-download-text" }, [
                        _c("span", { staticClass: "app-download-sub" }, [
                          _vm._v("Tải trên"),
                        ]),
                        _c("span", { staticClass: "app-download-name" }, [
                          _vm._v("Google Play"),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "app-download-link app-download-link--apple",
                      attrs: {
                        type: "button",
                        "aria-label": "Tải ứng dụng OneKids trên App Store",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.openExternalLink(_vm.socialLinks.appStore)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "app-download-icon" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "store-icon-svg",
                            attrs: {
                              viewBox: "0 0 24 24",
                              "aria-hidden": "true",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M15.3 3.2c.1 1-.3 2-1 2.8-.8.8-1.9 1.3-2.9 1.2-.1-1 .3-2 1-2.7.8-.8 2-1.3 2.9-1.3ZM18.7 17.6c-.5 1.1-.8 1.6-1.4 2.6-.8 1.3-1.9 2.9-3.3 2.9-1.2 0-1.5-.8-3.1-.8-1.6 0-2 .8-3.2.8-1.4 0-2.4-1.4-3.2-2.7-2.2-3.3-2.5-7.2-1.1-9.4 1-1.6 2.6-2.6 4.1-2.6 1.6 0 2.6.8 3.9.8 1.3 0 2.1-.8 3.9-.8 1.4 0 2.9.8 3.9 2.2-3.4 1.9-2.9 6.8.5 8Z",
                                fill: "currentColor",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _c("span", { staticClass: "app-download-text" }, [
                        _c("span", { staticClass: "app-download-sub" }, [
                          _vm._v("Tải trên"),
                        ]),
                        _c("span", { staticClass: "app-download-name" }, [
                          _vm._v("App Store"),
                        ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c(
                "button",
                {
                  staticClass: "copyright-link",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.openExternalLink(_vm.socialLinks.developer)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            Copyright 2017 Developer by OneGroup VietNam\n          "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }